/*
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
*/

import { parse, stringify } from '@vanillaes/csv'

const COL_ID_POINT = 0;
const COL_X = 1;
const COL_Y = 2;
const COL_ID_SEGMENT = 3;
const COL_CURVATURE = 4;
const COL_CENTRE_X = 5;
const COL_CENTRE_Y = 6;
const COL_SEGMSTARTANGLE = 7;
const COL_SEGMENDANGLE = 8;
const COL_LENGTH = 9;
const COL_NROFPOINTFUNCTIONS = 10;
const COL_NROFSEGMENTFUNCTIONS = 11;

class Segment {
    constructor(segmentarray) {
        this.segment = segmentarray;
        this.functionArray = this.getFunctionsArray();
        this.hasLine = this.IdentifierSegment == 1 ? false : true;
    }

    get IdentifierPoint() {
        return parseInt(this.segment[COL_ID_POINT]);
    }

    get X() {
        return parseFloat(this.segment[COL_X]);
    }

    set X(value) {
        this.segment[COL_X] = value.toString();
    }

    get Y() {
        return parseFloat(this.segment[COL_Y]);
    }

    set Y(value) {
        this.segment[COL_Y] = value.toString();
    }

    get IdentifierSegment() {
        return parseInt(this.segment[COL_ID_SEGMENT]);
    }

    get Curvature() {
        return parseFloat(this.segment[COL_CURVATURE]);
    }

    set Curvature(value) {
        this.segment[COL_CURVATURE] = value.toString();
    }

    get CentreX() {
        return parseFloat(this.segment[COL_CENTRE_X]);
    }

    set CentreX(value) {
        this.segment[COL_CENTRE_X] = value.toString();
    }

    get CentreY() {
        return parseFloat(this.segment[COL_CENTRE_Y]);
    }

    set CentreY(value) {
        this.segment[COL_CENTRE_Y] = value.toString();
    }

    get SegmStartAngle() {
        return parseFloat(this.segment[COL_SEGMSTARTANGLE]);
    }

    set SegmStartAngle(value) {
        this.segment[COL_SEGMSTARTANGLE] = value.toString();
    }

    get SegmEndAngle() {
        return parseFloat(this.segment[COL_SEGMENDANGLE]);
    }

    set SegmEndAngle(value) {
        this.segment[COL_SEGMENDANGLE] = value.toString();
    }

    get Length() {
        return parseFloat(this.segment[COL_LENGTH]);
    }

    set Length(value) {
        this.segment[COL_LENGTH] = value.toString();
    }

    get NrOfPointFunctions() {
        return parseInt(this.segment[COL_NROFPOINTFUNCTIONS]);
    }

    get NrOfSegmentFunctions() {
        return parseInt(this.segment[COL_NROFSEGMENTFUNCTIONS]);
    }

    getFunctionsArray() {
        var functionArray = [];

        var functionIndex = 12;
        for (let i = 0; i < this.NrOfPointFunctions + this.NrOfSegmentFunctions; i++) {
            var functionObject = {};
            var identifierFunction = Number(this.segment[functionIndex]);
            var nrOfArgsFunction = Number(this.segment[functionIndex + 1]);

            functionObject.IdentifierFunction = identifierFunction;
            functionObject.NrOfArgsFunction = nrOfArgsFunction;

            var argArray = [];
            for (let j = 0; j < nrOfArgsFunction; j++) {
                argArray.push(Number(this.segment[functionIndex + 2 + j]));
            }
            functionObject.Arguments = argArray;

            functionIndex += nrOfArgsFunction + 2;
            functionArray.push(functionObject);
        }
        return functionArray;
    }

    updateFunctionArray() {
        this.functionArray = this.getFunctionsArray();
    }

    addFunction(functionObject) {
        var id = functionObject.IdentifierFunction
        var nrOfArgs = functionObject.NrOfArgsFunction
        var args = functionObject.Arguments

        var functionIndex = this.getNextFunctionSlot();

        if (functionIndex + Number(args) + 2 > 41) {
            //console.log("NO ROOM FOR NEW FUNCTION")
            return false;
        }


        this.segment[functionIndex] = id
        this.segment[functionIndex + 1] = nrOfArgs

        for (let i = 0; i < nrOfArgs; i++) {
            this.segment[functionIndex + 2 + i] = args[i] ? args[i] : "0";
        }

        if (id >= 1 && id <= 50 || id >= 101 && id <= 150) {
            this.segment[COL_NROFPOINTFUNCTIONS] = (parseInt(this.segment[COL_NROFPOINTFUNCTIONS]) + 1).toString();
        } else if (id >= 51 && id <= 100 || id >= 151 && id <= 200) {
            this.segment[COL_NROFSEGMENTFUNCTIONS] = (parseInt(this.segment[COL_NROFSEGMENTFUNCTIONS]) + 1).toString();
        }

        this.updateFunctionArray()
        return true;
    }

    removeFunction(functionId) {
        var funcToRemove = this.functionArray.findIndex(functionObject => functionObject.IdentifierFunction == functionId)
        //console.log(funcToRemove)
        if (funcToRemove != -1) {
            this.functionArray.splice(funcToRemove, 1);
            this.createNewFunctionSegmentArray();

            if (functionId >= 1 && functionId <= 50 || functionId >= 101 && functionId <= 150) {
                this.segment[COL_NROFPOINTFUNCTIONS] = (parseInt(this.segment[COL_NROFPOINTFUNCTIONS]) - 1).toString();
            } else if (functionId >= 51 && functionId <= 100 || functionId >= 151 && functionId <= 200) {
                this.segment[COL_NROFSEGMENTFUNCTIONS] = (parseInt(this.segment[COL_NROFSEGMENTFUNCTIONS]) - 1).toString();
            }
        }
    }

    setFunctions(functionArray) {
        this.functionArray = functionArray;
        this.createNewFunctionSegmentArray();

        // foreach function in functionarray
        //if point function
        this.segment[COL_NROFPOINTFUNCTIONS] = (0).toString();
        this.segment[COL_NROFSEGMENTFUNCTIONS] = (0).toString();

        functionArray.forEach(functionObject => {
            var id = functionObject.IdentifierFunction
            if (id >= 1 && id <= 50 || id >= 101 && id <= 150) {
                this.segment[COL_NROFPOINTFUNCTIONS] = (parseInt(this.segment[COL_NROFPOINTFUNCTIONS]) + 1).toString();
            } else if (id >= 51 && id <= 100 || id >= 151 && id <= 200) {
                this.segment[COL_NROFSEGMENTFUNCTIONS] = (parseInt(this.segment[COL_NROFSEGMENTFUNCTIONS]) + 1).toString();
            }
        });
    }

    createNewFunctionSegmentArray() {
        var functionSegment = [];
        var functionSegmentIndex = 0;
        this.functionArray.forEach(functionObject => {
            functionSegment.push(functionObject.IdentifierFunction.toString());
            functionSegment.push(functionObject.NrOfArgsFunction.toString());
            functionSegmentIndex++
            functionSegmentIndex++
            for (let i = 0; i < functionObject.NrOfArgsFunction; i++) {
                functionSegment.push(functionObject.Arguments[i].toString());
                functionSegmentIndex++
            }
        })

        while (functionSegment.length < 29) {
            functionSegment.push("0")
        }

        this.segment.splice(12)
        this.segment.push(...functionSegment);
    }

    getNextFunctionSlot() {
        var functionIndex = 12;
        for (let i = 0; i < this.NrOfSegmentFunctions + this.NrOfPointFunctions; i++) {
            functionIndex++
            functionIndex += Number(this.segment[functionIndex]);
            functionIndex++
        }
        return functionIndex
    }

    changeArgForFunction(IdentifierFunction, argIndex, value) {
        var functionObject = this.functionArray.find(functionObject => functionObject.IdentifierFunction == IdentifierFunction);
        functionObject.Arguments[argIndex] = value;

        this.createNewFunctionSegmentArray();
    }
}

const COL_TYPE_VALUE = 1;
const COL_VERSION_VALUE = 3;
const COL_DATETIME_VALUE = 5;

export default class Motionplan {
    #parsed;

    constructor(motionplan, id = null, name = null) {
        this.id = id
        this.name = name
        this.motionplan = motionplan;
        this.headerarray = [];
        this.data = [];

        this.#parsed = parse(this.motionplan);
        this.parseMotionplan();
    }

    //Logfile details
    get Type() {
        return this.headerarray[0][COL_TYPE_VALUE];
    }

    get Version() {
        return this.headerarray[0][COL_VERSION_VALUE];
    }

    get DateTime() {
        return this.headerarray[0][COL_DATETIME_VALUE];
    }

    //Software details
    get MISSoftwareVersion() {
        return this.headerarray[1][1];
    }

    //Task details
    get TaskId() {
        return this.headerarray[2][1];
    }

    get TaskName() {
        return this.headerarray[2][3];
    }

    get Projection() {
        return this.headerarray[2][5];
    }

    get Unit() {
        return 6;
    }

    get OperationPractice() {
        // if (this.headerarray[0][COL_VERSION_VALUE] == "001") {
        //     return this.headerarray[2][7];
        // }
        return this.headerarray[2][9];
    }

    get OperationTechnique() {
        // if (this.headerarray[0][COL_VERSION_VALUE] == "001") {
        //     return this.headerarray[2][9];
        // }
        return this.headerarray[2][11];
    }

    get DataTransferOrigin() {
        // if (this.headerarray[0][COL_VERSION_VALUE] == "001") {
        //     return this.headerarray[2][11];
        // }
        return this.headerarray[2][13];
    }

    getMotionplanString() {
        var motionplanarray = parse(stringify(this.headerarray));
        this.data.forEach(segment => {
            motionplanarray.push(segment.segment);
        });
        return stringify(motionplanarray);
    }

    parseMotionplan() {
        if (this.#parsed.length <= 5)
            console.log("Motionplan, expected at least 5 lines");

        // line 1
        if (this.#parsed[0].length != 6)
            console.log("Motionplan line 1, expected 6 items");
        this.headerarray.push(this.#parsed[0]);

        // line 2
        if (this.#parsed[1].length != 2)
            console.log("Motionplan line 2, expected 2 items");
        this.headerarray.push(this.#parsed[1]);

        // line 3
        // if version 001 then 12 items, if version is 002 then 14 items
        if ((this.Version == "001" && this.#parsed[2].length != 12) || this.#parsed[2].length != 14 ){
            // console.log("Motionplan line 3, expected 14 items");
            var a;
        }
        this.headerarray.push(this.#parsed[2]);

        // line 4
        if (this.#parsed[3].length % 2)
            console.log("Motionplan line 2, expected even number of items");
        this.headerarray.push(this.#parsed[3]);

        // data
        var line = 4;

        for (; line < this.#parsed.length; line++) {
            let linedata = this.#parsed[line];
            // if (linedata.length != 20)
            //     console.log(`Motionplan line ${line}, expected 20 items`);
            this.data.push(new Segment(linedata));
        }
    }

    addSegment(linedata) {
        const id = this.data.length + 1

        linedata[COL_ID_POINT] = id.toString()
        linedata[COL_ID_SEGMENT] = id.toString()
        this.data.push(new Segment(linedata));

        this.motionplan = this.getMotionplanString()
    }

    removeLastSegment() {
        this.data.pop()

        this.motionplan = this.getMotionplanString()
    }

    removeFirstSegment() {
        this.data.shift()

        this.motionplan = this.getMotionplanString()
    }

    disconnectAt(index) {
        // make two coppies
        const clone1 = new Motionplan(this.motionplan, null, this.name + "-1");
        const clone2 = new Motionplan(this.motionplan, null, this.name + "-2");

        //remove the end part from clone 1 and assign to clone 2
        clone2.data = clone1.data.splice(index)

        //remove the segmentfunction from the first segment of clone 2
        clone2.data[0].removeFunction(51)

        // update motionplan string for both motionplan objects
        clone1.motionplan = clone1.getMotionplanString()
        clone2.motionplan = clone2.getMotionplanString()

        return [clone1, clone2]
    }

    convert(conversion) {
        for (let segment of this.data) {
            segment.X *= conversion;
            segment.Y *= conversion;
            segment.Curvature = 1 / ((1 / segment.Curvature) * conversion);
            segment.CentreX *= conversion;
            segment.CentreY *= conversion;
            segment.Length *= conversion;
        }
    }
}